export var FILE_ERRORS = {
  size: 'Слишком большой размер файла',
  type: 'Неподходящий тип файла'
};
export var MAX_KB = 1000000;
export var COEFFICIENT_KB = 1000;